<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Personales y Familia</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguros Exequiales</h1>
                <p>Seguros Exequiales: compromiso con tu tranquilidad</p>
        </div>
        <div class="colectivo">
            <center>
                <div>
                    <div class="img">
                        <img src="@/assets/Empresariales-Seguro-Colectivo/4.png" alt="">
                    </div>
                    <div class="informacion">
                        <p>Cuando fallece un ser querido es importante no preocuparse por cuestiones económicas y tener un seguro que garantice todos los gastos necesarios en ese momento. Te
                        acompañamos y ofrecemos beneficios que puedes recibir en vida
                        <br>
                        <br>
                        El fallecimiento de un ser querido es una situación difícil en la que contar con el mejor apoyo hace la diferencia. En caso de ser tú el que muera, imagínate lo que significa para tus
                        familiares y amigos tener el respaldo que el Seguros Exequiales les brinda.
                        <br>
                        <br>
                        Cero preocupaciones por tener que asumir del bolsillo propio grandes sumas de dinero en gastos funerarios; nosotros les damos a ellos o a ti, según sea el caso, entre $3 millones y $7
                        millones para pagar todo con la ventaja de que, si sobra dinero, este se entrega a los beneficiarios.
                        <br>
                        <br>
                        Sabemos que la ausencia de alguien a quien se ama nunca puede llenarse, pero tenemos la certeza de que estando ahí incondicionalmente nos aseguramos de celebrar la vida junto a
                        quienes han depositado su confianza en Nosotros.</p>
                    </div>
                </div>
            </center>
        </div>
        <div class="move"><center><img src="@/assets/Seguro-vida/7.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados
    },
    data() {
        return {
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-bg-personas-familias.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 50px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service {
        width: 100%;
    }
    .services > center > div > div > .service > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 35px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .colectivo {
        background: -webkit-gradient(linear,left bottom, right top,color-stop(30%, #f7ebff), to(#cbe5fe));
        background: linear-gradient(to top right,#f7ebff 30%, #cbe5fe 100%);
    }
    .colectivo > center {
        padding: 50px 200px;
    }
    .colectivo > center > p {
        font-family: 'JR';
        text-align: left;
        font-size: 22px;
        line-height: 25px;
    }
    .colectivo > center > div {
        display: flex;
    }
    .colectivo > center > div > .informacion {
        padding-top: 120px;
        text-align: left;
        padding-left: 50px;
    }
    .colectivo > center > div > .informacion > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 20px;
    }
    .colectivo > center > div > .informacion > p {
        font-family: 'JR';
        font-size: 22px;
        line-height: 25px;
        margin-bottom: 20px;
    }
    .colectivo > center > div > .informacion > button {
        font-family: 'JR';
        background-color: #2d4f98;
        color: #fff;
        border-radius: 14px;
        padding: 7px 25px 7px 25px;
        border-style: none;
        font-weight: bolder;
        font-size: 18px;
        border-style: solid;
        border-color: #2d4f98;
    }
    .colectivo > center > div > .informacion > button:hover {
        background:#65b24a;
        color: #fff;
        border-color: #fff;
        border-style: solid;
    }
    .plan > center {
        padding: 50px 200px;
    }
    .plan > center > div{
        display: flex;
    }
    .plan > center > div > div {
        padding-top: 30px;
        text-align: left;
    }
    .plan > center > div > img {
        width: auto;
        height: auto;
    }
    .plan > center > div > div > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .plan > center > div > div > p {
        font-family: 'JR';
        font-size: 18px;
        line-height: 25px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }

    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .colectivo > center {
            padding: 50px 100px;
        }
        .plan > center {
            padding: 50px 100px;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .colectivo > center {
            padding: 50px 50px;
        }
        .plan > center {
            padding: 50px 50px;
        }
    }
    @media (max-width: 1200px) {
        .plan > center > div {
            display: block;
        }
        .plan > center > div > img {
            width: 70%;
            height: auto;
        }
    }
    @media (max-width: 1100px) {
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .services {
            padding: 0px 50px;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .colectivo > center > div > .informacion {
            padding-left: 0px;
            padding-top: 50px;
        }
        .colectivo > center > div > .informacion > h1 {
            font-size: 30px;
        }
        .plan > center > div > div > h1 {
            font-size: 30px;
        }
        .plan > center > div > div > p {
            font-size: 18px;
        }
        .plan > center > div > img {
            width: 95%;
            height: auto;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .colectivo > center > div {
            display: block;
        }
        .colectivo > center > div > .img > img {
            width: 100%;
        }
        .colectivo > center > p {
            font-size: 18px;
        }
        .colectivo > center > div > .informacion > h1 {
            font-size: 25px;
        }
        .colectivo > center > div > .informacion > p {
            font-size: 18px;
        }
        .plan > center > div > div > h1 {
            font-size: 25px;
        }
        .plan > center > div > div > p {
            font-size: 18px;
        }
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .move > center > img {
            width: 250px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/SeguroExequias.vue